module.exports = __webpack_public_path__ + "img/Logo.4aefc46d.svg";